import { render, staticRenderFns } from "./Templates.vue?vue&type=template&id=42b745ef&scoped=true&"
import script from "./Templates.vue?vue&type=script&lang=js&"
export * from "./Templates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b745ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42b745ef')) {
      api.createRecord('42b745ef', component.options)
    } else {
      api.reload('42b745ef', component.options)
    }
    module.hot.accept("./Templates.vue?vue&type=template&id=42b745ef&scoped=true&", function () {
      api.rerender('42b745ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Templates.vue"
export default component.exports